import React from 'react'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import CardUI from '../../../widgets/layout/CardUI'
import './FailedExternalPage.css'

const ExternalDataCachePageUI = ({
  context,
  errorList,
  externalDataCacheList,
  lastKey,
  hasMore,
  hasPrevious,
  gettingMore,
  currentPage,
  onRefreshClick,
  onNextClick,
  onPreviousClick,
  onDeleteClick
}) => {
  return (
    <SuperUserHomePageUI
      context={context}
      className='pg_su_external_data_cache'
      topnav='accounts'
      page='externalDataCache'
      dimension='w1600'
    >
      {(!externalDataCacheList && !errorList) && <SpinnerComponentUI />}

      {errorList && errorList.length > 0 && (
        <GenericErrorUI error={errorList[0]} />
      )}

      {externalDataCacheList && (
        <LRTableActionsUI
          location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>External Data Cache</b></span>
            </span>
          }
        />
      )}

      {externalDataCacheList && externalDataCacheList.length === 0 && (
        <EmptyListUI context={context} createEnabled={false} createDisabledMessageLabel='No External Data Cache' />
      )}

      {externalDataCacheList && externalDataCacheList.length > 0 && (
        <div className='table-container-wrapper'>
          <CardUI className='g_no_margin enhanced-card'>
            <div className='table-header'>
              <div className='table-stats'>
                <span className='stat-item'>
                  <strong>Total Records:</strong> {externalDataCacheList.length}
                </span>
                <span className='stat-item'>
                  <strong>Page:</strong> {currentPage}
                </span>
              </div>
            </div>
            <div className='table-scroll-container'>
              <table className='enhanced-table'>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Key</th>
                    <th>Value</th>
                    <th>Created</th>
                    <th>Updated</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {externalDataCacheList.map((item, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                      <td>{item.type}</td>
                      <td>{item.key}</td>
                      <td>{item.value}</td>
                      <td>{item.dateCreatedEpoch ? new Date(item.dateCreatedEpoch).toLocaleString() : '-'}</td>
                      <td>{item.dateUpdatedEpoch ? new Date(item.dateUpdatedEpoch).toLocaleString() : '-'}</td>
                      <td>
                        <span
                          className='icon icon-trash-o g_m_left_50 g_m_right_50'
                          title='Delete'
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            if (window.confirm('Are you sure you want to delete this item?')) {
                              onDeleteClick(item.id)
                            }
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardUI>
          {(hasMore || hasPrevious) && (
            <div className='pagination-container'>
              <div className='pagination-buttons'>
                {hasPrevious && (
                  <button
                    className={`pagination-btn prev-btn ${gettingMore ? 'loading' : ''}`}
                    onClick={onPreviousClick}
                    disabled={gettingMore}
                  >
                    {gettingMore ? (
                      <>
                        <span className='spinner'></span>
                        <span>Loading...</span>
                      </>
                    ) : (
                      <>
                        <span className='btn-icon'>⬅️</span>
                        <span>Previous</span>
                      </>
                    )}
                  </button>
                )}

                {hasMore && (
                  <button
                    className={`pagination-btn next-btn ${gettingMore ? 'loading' : ''}`}
                    onClick={onNextClick}
                    disabled={gettingMore}
                  >
                    {gettingMore ? (
                      <>
                        <span className='spinner'></span>
                        <span>Loading...</span>
                      </>
                    ) : (
                      <>
                        <span className='btn-icon'>➡️</span>
                        <span>Next</span>
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </SuperUserHomePageUI>
  )
}

export default ExternalDataCachePageUI


